<template lang='pug'>
  div
    v-tooltip(right)
      template(v-slot:activator='{on}')
        v-btn(v-on='on' @click='showDialog = !showDialog' text icon color='primary')
          v-icon add
      span Create Dashboard
    v-dialog(v-model='showDialog' max-width='500px')
      v-form(
        ref='createDashboardForm'
        v-model='createDashboardForm'
        v-if='showDialog'
        @submit.prevent='createDashboard')
        v-card
          v-card-title
            span.text-h5.primary--text.text--lighten-2 Create Dashboard
          v-card-text
            v-text-field(
              label='Name'
              v-model='dashboard.name'
              :rules='[(v) => !!v || "Name is required"]'
              required
              autofocus)
            select-branch.mt-2(
              label='Select or Create Branch'
              v-if='gitMode'
              v-model='dashboard.gitBranch'
              :rules='[(v) => !!v || "Git Branch is required"]'
              required
              :customMessage='createBranchMessage'
              @branchesLoaded='(branches) => possibleBranches = branches'
              @input='checkIfCreatingBranch')
            tags.mt-2(v-model='dashboard.tags')
            v-textarea.mt-2(
              label='Description'
              v-model='dashboard.description'
              @keypress.ctrl.enter='createDashboard'
              outlined
              auto-grow)
          v-card-actions
            v-spacer
            v-btn(text @click.native='showDialog=false') Cancel
            v-btn(text color='primary' type='submit' :loading='loading') Create
</template>

<script>
import {get} from 'lodash';
import {mapGetters, mapActions} from 'vuex';
import Dashboard from '../api/dashboard';
import Notifications from '../services/notification.service';
import SelectBranch from './SelectBranch';
import Tags from './Tags';

export default {
  name: 'BionicMetricsCreateDashboard',
  components: {Tags, SelectBranch},
  mounted() {
    if (this.requestingCreate) this.showDialog = true;
    this.dashboard.gitBranch = this.gitBranch;
  },
  computed: {
    requestingCreate() {
      return get(this.$route, 'query.create', false);
    },
    ...mapGetters({
      user: 'getUser',
      account: 'getAccount',
      gitMode: 'getGitMode',
      gitBranch: 'getGitBranch'
    })
  },
  methods: {
    open() {
      this.showDialog = true;
    },
    checkIfCreatingBranch(branch) {
      if (!branch) {
        this.createBranchMessage = null;
      }
      if (!this.possibleBranches.includes(branch)) {
        this.createBranchMessage = `Branch "${branch}" will be created from "${this.gitBranch}"`;
      } else {
        this.createBranchMessage = null;
      }
    },
    async createDashboard() {
      if (!this.createDashboardForm) {
        this.$refs.createDashboardForm.validate();
        return;
      }
      try {
        this.loading = true;
        const dashboard = await Dashboard.create(this.dashboard);
        this.showDialog = false;
        const path = this.gitMode ? dashboard.gitBranch : dashboard.guid;
        if (this.gitMode) {
          await this.gitChangeBranch({branch: dashboard.gitBranch, reload: false});
          Notifications.toast(`Git branch successfully changed to <strong>${dashboard.gitBranch}</strong>`);
        }
        await this.$router.push(`/dashboard/${path}`);
      } catch (error) {
        const message = get(error, 'response.data.message');
        if (message === 'DUPLICATE') return Notifications.alert(`The branch <strong>${this.dashboard.gitBranch}</strong> is already assigned to an existing dashboard. Please choose or create a different branch.`);
        console.error(`Error creating dashboard: ${error.message}`);
        console.error(message);
        if (message) await Notifications.alertError('Error creating the dashboard. Error Details:', message);
        else await Notifications.alert('There was a problem creating the dashboard');
      } finally {
        this.loading = false;
      }
    },
    ...mapActions({gitChangeBranch: 'gitChangeBranch'})
  },
  data() {
    return {
      loading: false,
      createDashboardForm: null,
      showDialog: false,
      createBranchMessage: null,
      possibleBranches: null,
      dashboard: {
        name: null,
        description: null,
        gitBranch: null,
        tags: null
      }
    };
  }
};
</script>

<style scoped>

</style>
